import CryptoJS from "crypto-js";
import { SITURL, PPURL, DEVURL, SIT2URL } from '../constants'

const win: any = window;
const retryCount = win["AllowedAPIRetryCount"] || 4;
const delay = 1000;

const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;
let utilUrl = baseUrl;

if (baseUrl.includes('apisit')) {
    utilUrl = SITURL;
} else if (baseUrl.includes('apipreprod')) {
    utilUrl = PPURL;
} else if (baseUrl.includes('apidev')) {
    utilUrl = DEVURL;
} else if (baseUrl.includes('apisit2')) {
    utilUrl = SIT2URL;
}

const tokenService = async (request: any) => {
    const url = `${utilUrl}/mobilyTheme4/BzFvwmzXvs`;

    const encryptedBase64Key = win["por_redk"];

    if (!encryptedBase64Key) {
        throw new Error("Encryption key is missing.");
    }

    const parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);

    const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(request),
        parsedBase64Key,
        {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    const options: any = {
        method: "POST",
        headers: baseUrl.includes("mobily.com.sa")
            ? new Headers({
                  "Content-Type": "application/text",
                  "trans_id": win["trans_id"]
              })
            : {},
        body: encryptedData,
    };

    for (let attempt = 1; attempt <= retryCount; attempt++) {
        try {
            const res = await fetch(url, options);

            if (!res.ok) {
                throw new Error(`HTTP Error: ${res.status}`);
            }

            const data = await res.text();

            const decrypted = CryptoJS.AES.decrypt(data, parsedBase64Key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            });

            const response = JSON.parse(
                decrypted.toString(CryptoJS.enc.Utf8)
            );

            console.log("responseToken",response)

            if (response?.ab && response?.ab !== 'null') {
                return response?.ab;
            }

            throw new Error("Invalid API response");

        } catch (err) {

            console.log(`Attempt ${attempt} failed`, err);

            if (attempt === retryCount) {
                throw err;
            }

            await new Promise(resolve =>
                setTimeout(resolve, delay)
            );
        }
    }
};

export default tokenService;